import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import tokens from "../_tokens"
import { Details, Link } from "./"

const StyledList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`

const StyledLink = styled(Link)`
  color: ${tokens.color.text.muted};
  font-size: ${tokens.fontSize.text.s};
  padding-bottom: 15px;
  display: inline-block;
`

const IconSpan = styled.span`
  font-size: ${tokens.fontSize.heading.l};
  margin-right: ${tokens.size.base}px;
`

const StyledTOCHeader = styled.span`
  font-size: ${tokens.fontSize.heading.s};
  padding-bottom: ${0.5 * tokens.size.base}px;
  display: inline-block;
  ${props => props.isCollapsible && `cursor: pointer;`};
`

function TableOfContentsSection({ items, depth }) {
  return (
    <StyledList>
      {items.map(item => (
        <li
          key={item.url}
          css={{ paddingLeft: depth > 0 ? 2 * tokens.size.base : 0 }}
        >
          <StyledLink to={item.url}>{item.title}</StyledLink>
          {item.items ? (
            <TableOfContentsSection items={item.items} depth={depth + 1} />
          ) : null}
        </li>
      ))}
    </StyledList>
  )
}

function TableOfContents({ isCollapsible = false, items }) {
  return isCollapsible ? (
    <Details>
      {({ open }) => (
        <>
          <summary style={{ fontWeight: 600 }}>
            {open ? (
              <IconSpan>&#x2304;</IconSpan>
            ) : (
              <IconSpan>&#x203A;</IconSpan>
            )}
            <StyledTOCHeader isCollapsible={isCollapsible} isOpen={open}>
              Table of contents
            </StyledTOCHeader>
          </summary>
          <div style={{ paddingTop: 0.5 * tokens.size.base }}>
            <TableOfContentsSection items={items} />
          </div>
        </>
      )}
    </Details>
  ) : (
    <>
      <StyledTOCHeader>Table of contents</StyledTOCHeader>
      <TableOfContentsSection items={items} />
    </>
  )
}

TableOfContents.propTypes = {
  isCollapsible: PropTypes.bool,
  items: PropTypes.array,
}
TableOfContentsSection.propTypes = {
  depth: PropTypes.number,
  items: PropTypes.array,
}

TableOfContentsSection.defaultProps = {
  depth: 0,
}

export default TableOfContents
